import './success-text.less';
import React from 'react';
import PropTypes from 'prop-types';
import telegramIcon from '../../../../assets/img/market/telegram-dark.svg';
import mailIcon from '../../../../assets/img/market/mail-dark.svg';

class SuccesText extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		const { intl, is_exchange_allowed } = this.props;
		return <div className="succes-text">
			<span className="succes-text__highlight">{intl('Thanks for order')}</span>
			<br />
			<br />
			{is_exchange_allowed ? intl('QUID exchange processed') : intl('Ticket for address')}
			<br />
			{is_exchange_allowed ? intl('Transaction completed') : (
				<span className="succes-text__highlight">{intl('Fill form please')}</span>
			)}
			<br />
			<p>{intl('Have a question?')}</p>
			<div className="succes-text__contacts">
				<div className="succes-text__contacts-item">
					<div className="succes-text__contacts-img">
						<img src={mailIcon} alt="mail"/>
					</div>
					<a
						href="mailto:d.udinceva@rocketprofit.com"
						className="succes-text__contacts-link">d.udinceva@rocketprofit.com</a>
				</div>
				<div className="succes-text__contacts-item">
					<div className="succes-text__contacts-img">
						<img src={telegramIcon} alt="telegtam"/>
					</div>
					<a
						href="https://t.me/DariaYudintseva" className="succes-text__contacts-link">@DariaYudintseva</a>
				</div>
			</div>
		</div>;
	}
}

SuccesText.propTypes = {
	intl: PropTypes.func,
	is_exchange_allowed: PropTypes.bool
};

export default SuccesText;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/modal-popup/success-text.js